import { combineReducers } from 'redux';
// import demoReducers from '../CfdiModule/reducers';

const Reducers = combineReducers({
	// demoReducers
});

export default Reducers;
